import type { CanvasDocumentV3 as CanvasDocument } from "@seedance/contracts";

export interface CanvasGroupBounds {
  id: string;
  label: string;
  color: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

const groupPadding = 24;

export function canvasGroupBounds(document: CanvasDocument): CanvasGroupBounds[] {
  const nodesById = new Map(document.nodes.map((node) => [node.id, node]));
  return document.groups.flatMap((group) => {
    const nodes = group.nodeIds.flatMap((nodeId) => {
      const node = nodesById.get(nodeId);
      return node === undefined ? [] : [node];
    });
    if (nodes.length === 0) return [];
    const left = Math.min(...nodes.map((node) => node.position.x)) - groupPadding;
    const top = Math.min(...nodes.map((node) => node.position.y)) - groupPadding;
    const right = Math.max(...nodes.map((node) => node.position.x + node.size.width)) + groupPadding;
    const bottom = Math.max(...nodes.map((node) => node.position.y + node.size.height)) + groupPadding;
    return [{
      id: group.id,
      label: group.label,
      color: group.color,
      x: left,
      y: top,
      width: right - left,
      height: bottom - top
    }];
  });
}
